var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUserGray = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#F3F7F8",
    stroke: "#68808C",
    className: "externalBorder"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17,
    fill: "#E7EEF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1766_9397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 34
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.5,
    fill: "#C4C4C4",
    stroke: "#68808C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1766_9397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15.75,
    r: 6.3,
    fill: "#CBD6DC",
    stroke: "#68808C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 33.6,
    r: 11.4,
    fill: "#CBD6DC",
    stroke: "#68808C"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/user_gray.ade1a02e.svg";
export { ForwardRef as ReactComponent };